<template>
  <section id="financials">

    <b-container>
      <h5>Financials 2017</h5>
      <h6>Ahlstrom-Munksjö's financial statements for 2017 include the 2017 figures as well as all the comparison figures presented on a pro forma basis to illustrate the financial impact of the merger between Ahlstrom and Munksjö.</h6>
      <p class="financial-symbole-info-text">We use the following symbols throughout the financial statements to make it easier for the reader.</p>
      <b-row>
        <b-col cols="12" md="6" lg="3" class="d-flex">
          <div class="financial-teasers">
            <div class="icon-round-background icon-financials1">
            </div>
            <p>This symbol describes the accounting policies applied to the specific financial statement item.</p>
          </div>
        </b-col>
        <b-col cols="12" md="6" lg="3" class="d-flex">
          <div class="financial-teasers">
            <div class="icon-round-background icon-financials2">
            </div>
            <p>This symbol is used when the specific item require management to make certain judgements, estimates and assumptions.</p>
          </div>
        </b-col>
        <b-col cols="12" md="6" lg="3" class="d-flex">
          <div class="financial-teasers">
            <div class="icon-round-background orange icon-financials3">
            </div>
            <p>This symbol highlights where additional unaudited information
is displayed.</p>
          </div>
        </b-col>
        <b-col cols="12" md="6" lg="3" class="d-flex">
          <div class="financial-teasers">
            <div class="icon-round-background icon-financials4">
            </div>
            <p>This symbol is used with a disclosure on a specific risk related to the financial statement item.</p>
          </div>
        </b-col>
      </b-row>
      <div class="btn-container">
        <a 	:href="$creo.browserPdfLink(pdfLinks.full, pdfLinks.financial, 64)"
	        	class="btn btn-black-trans"
		        target="_blank">
		      Financial report 2017
		    </a>
      </div>
    </b-container>

  </section>
</template>

<script>
  import full from '../assets/pdf/full-report.pdf';
  import financial from '../assets/pdf/financial.pdf';

  export default {
    name: 'Financials',
    data() {
      return {
        pdfLinks: {
          'full': full,
          'financial': financial
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/sections/Financials.vue